import React from "react";
import { Lightbulb } from "lucide-react";
import { useTranslation } from "react-i18next";

// Shown with the "metaphore" / "poeme" formats: a notion alone is enough, with clickable examples.
export function MetaphorHint({ onPick, poem = false }) {
  const { t } = useTranslation();
  const examples = t("metaphor_hint.examples", { returnObjects: true });
  return (
    <div className="mx-6 md:mx-8 lg:mx-10 mb-6 border border-[#002FA7] bg-[#002FA7]/5 p-4" data-testid="metaphor-hint">
      <div className="flex items-center gap-2 font-mono uppercase tracking-[0.2em] text-[10px] text-[#002FA7] mb-2">
        <Lightbulb className="w-3 h-3" /> {t("metaphor_hint.title")}
      </div>
      <p className="text-sm leading-relaxed">{t(poem ? "metaphor_hint.poem_body" : "metaphor_hint.body")}</p>
      <div className="flex flex-wrap items-center gap-2 mt-3">
        <span className="text-xs text-muted-foreground">{t("metaphor_hint.try")}</span>
        {examples.map((ex, i) => (
          <button key={ex} type="button" onClick={() => onPick(ex)} data-testid={`metaphor-hint-example-${i}`}
            className="text-xs px-3 py-1 border border-[#002FA7] text-[#002FA7] hover:bg-[#002FA7] hover:text-white transition-colors">
            {ex}
          </button>
        ))}
      </div>
    </div>
  );
}

export default MetaphorHint;
